import React, {useState, useEffect} from 'react';
import { Table } from 'react-bootstrap'

const CredentialTable = ({ credentials }) => {
    const [vcData, setVCData] = useState([]);
    
    useEffect(() => {
      const removeProp = (obj, propToDelete) => {
        for (let property in obj) {
          if (obj.hasOwnProperty(property)) {
            if (property === propToDelete) {
              delete obj[property];
            } else if (typeof obj[property] == "object") {
              removeProp(obj[property], propToDelete);
            }
          }
        }
        return obj
      }

      const initialiseVCData = (vcData) => {
        let processedVCData = []
        for (let vc in vcData) {
          processedVCData[vc] = vcData[vc].credential.credentialSubject.data
          processedVCData[vc] = removeProp(processedVCData[vc], '@type')
        }
        return processedVCData
      }

      setVCData(initialiseVCData(credentials))
    }, [credentials])

    const extractItemFromIDDocument = (cred) => {
      if (cred.hasIDDocument){
        return JSON.parse(cred.hasIDDocument.hasIDDocument.idClass).item
      } else {
        return null
      }
    }

    return <div>
        <Table bordered>
              <thead className="thead-light">
                <tr>
                  <th>Index</th>
                  <th>Issue Date</th>
                  <th>Given Name</th>
                  <th>Family Name</th>
                  <th>Item</th>
                  <th>Issuer</th>
                  <th>VC Type</th>
                </tr>
              </thead>
              <tbody>
                {
                  vcData.map((cred, index) => {
                    return (
                      <tr key={index+1}>
                        <th scope='row'>{index+1}</th>
                        <td>{cred.hasIDDocument ?  cred.hasIDDocument.hasIDDocument.issueDate : 'ID Document'}</td>
                        <td>{cred.givenName || cred.name}</td>
                        <td>{cred.familyName || ''}</td>
                        <td>{cred.item || extractItemFromIDDocument(cred) || '' }</td>
                        <td>{cred.hasIDDocument ?  cred.hasIDDocument.hasIDDocument.issuer : 'ID Document'}</td>
                        <td>{cred.hasIDDocument ?  cred.hasIDDocument.hasIDDocument.documentType : 'ID Document'}</td>
                      </tr>
                    )
                  })
                }
              </tbody>
            </Table>
    </div>
}

export default CredentialTable;